module.exports = __webpack_public_path__ + "media/student_v2/assets/images/pin_location-97c9819942c19a43f8dd775a883da7d6.svg";